var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 17C2.25 19.6234 4.37665 21.75 7 21.75L17 21.75C19.6234 21.75 21.75 19.6234 21.75 17L21.75 13C21.75 10.3766 19.6234 8.25 17 8.25L16.5 8.25C16.0858 8.25 15.75 8.58579 15.75 9C15.75 9.41421 16.0858 9.75 16.5 9.75L17 9.75C18.7949 9.75 20.25 11.2051 20.25 13L20.25 17C20.25 18.7949 18.7949 20.25 17 20.25L7 20.25C5.20507 20.25 3.75 18.7949 3.75 17L3.75 13C3.75 11.2051 5.20507 9.75 7 9.75L7.5 9.75C7.91421 9.75 8.25 9.41421 8.25 9C8.25 8.58579 7.91421 8.25 7.5 8.25L7 8.25C4.37665 8.25 2.25 10.3766 2.25 13L2.25 17ZM8.46967 12.5303C8.17678 12.2374 8.17678 11.7626 8.46967 11.4697C8.76256 11.1768 9.23744 11.1768 9.53033 11.4697L11.25 13.1893L11.25 3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3L12.75 13.1893L14.4697 11.4697C14.7626 11.1768 15.2374 11.1768 15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L12.5303 15.5303C12.2374 15.8232 11.7626 15.8232 11.4697 15.5303L8.46967 12.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.15a9f4e657d5928a44830aa82306a589.svg";
export { ForwardRef as ReactComponent };